import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/types';
import { fetchPartnerContentClient } from 'src/services/contentstack/fetchPartnerContentClient';
import type { ContentstackPartner } from 'src/services/contentstack/types/PartnerPage.types';
import { fetchPartnerInsightsClient } from 'src/services/partner-product-insights-api/fetchPartnerInsightsClient';
import type { PartnerProductInsightsAPIPartner } from 'src/services/partner-product-insights-api/types/PartnerProductInsightsAPIPartner';

export interface RequestPartnerContentOptions {
  shortcode: string;
}

export const requestPartnerContent = createAsyncThunk<
  ContentstackPartner | null,
  RequestPartnerContentOptions
>('partner/requestPartnerContent', async ({ shortcode }, { getState }) => {
  const { contentPreview } = (getState() as ReduxApplicationState).user;

  return fetchPartnerContentClient(shortcode, { preview: contentPreview === true });
});

export interface RequestPartnerInsightsOptions {
  shortcode: string;
}

export const requestPartnerInsights = createAsyncThunk<
  PartnerProductInsightsAPIPartner | null,
  RequestPartnerInsightsOptions
>('partner/requestPartnerInsights', async ({ shortcode }) => {
  const data = await fetchPartnerInsightsClient(shortcode);

  return data;
});
